import terms from "./terms/en";
import areas from "./areas/en";
import nogame from "./en_nogame";

export default {
  translation: {
    nogame: nogame.translation,
    login: {
      title: "Log in",
      insert: "Enter the 10-digit alphanumeric code that was provided to you",
      or: "or",
      qr: "Scan the QR code",
      qr_back: "Go back",
      exit: "Exit",
      retry: "Try again",
      failed_1: "Authentication failed.",
      failed_2:
        "Make sure you have typed the token correctly, respecting upper and lower case.",
      failed_active:
        "Your token is not active yet. It will be effective from the following date:",
      failed_expired: "Your token is no longer valid.",
    },
    footer: {
      help: "Help! My code or QR is not working",
    },
    overlay: {
      close: "CLOSE",
      undo: "CANCEL",
      help: "Do you need technical help? Write an email to:",
      alert_valid: "Please choose a valid option before continuing!",
      alert_terms:
        "Before proceeding, you must fill in your personal details and accept the terms and conditions! Also check that you have entered the information correctly.",
      confirm_vincolato:
        "You are about to start the game. Once you click OK, you will have 20 minutes to get the best score. Make sure you have carefully read and understood all the instructions. Also make sure you have time, a stable connection, and a comfortable, quiet location. We suggest that you start the game from a PC with a mouse for the best playing conditions.",
      confirm_libero: "Do you really want to exit the game?",
      receive_mail:
        "Enter your email to receive the detailed profile in pdf format.",
      receive_mail_placeholder: "Write your email here",
      mail_success: "Email sent successfully!",
      mail_error: "Error while sending the email.",
      alert_logout_1:
        " Warning! Upon exiting, you will no longer be able to recover your progress.",
      alert_logout_2: "If you want to re-enter later, keep this link: ",
    },
    user: {
      welcome: "Welcome",
      app_description_1: `
        Q8 makes use of <b>PlayYourJob</b> to assess the characteristics of candidates. It is an assessment tool developed and validated by Laborplay, a spin-off of the <b>University of Florence</b>.
      `,
      app_description_2: `
        PlayYourTest is a self-assessment tool for soft skills that takes up to 30 minutes to complete. Your answers will help create a skills profile, highlighting your strengths and areas for improvement. At the end of the test, you’ll receive a report with the details of your profile.
      `,
      app_description_3: `
        {n} performance-mode games to complete in a maximum of 20 minutes to achieve the best score.
      `,
      active_title: "Active packages",
      loading: "LOADING...",
      confirm: "CONFIRM AND START",
      anagraphics: {
        title: "Personal details",
        description:
          "Fill in the following fields to complete the tasks and save your results.",
        name: "Name",
        name_placeholder: "Please enter your name here",
        surname: "Surname",
        surname_placeholder: "Type your surname here",
        cf: "Social Security Number",
        cf_placeholder: "Enter your Social Security Number here",
        email_placeholder: "Enter your e-mail here",
        year: "Age",
        under_25: "From 16 to 25 years old",  
        over_25: "More than 25 years old",  
        gender: "Gender",
        male: "Male",
        female: "Female",
        no_gener: "I prefer not to specify it",
        frequency: "How often you play",
        never: "Never",
        monthly: "Monthly",
        weekly: "Weekly",
        daily: "Every day",
        hourly: "Multiple times a day",
      },
    },
    games: {
      open: "Open",
      results: "Results",
      title: "Put your skills to the test",
      title_libero: "Free Play",
      close: "Close",
      retry: "Try Again",
      game_order:
        "Before you can play this game, you have to play the previous ones",
      before_rank: "Better than ",
      after_rank: " the players",
      test: "Go to the Test",
    },
    profile: {
      repeat: "Repeat test",
      own: "Your PLAY profile is: ",
      download: "Download your profile",
      title: "List of soft skills characteristic of this area",
      description:
        "Scores equal to or greater than 4 represent the gradually increasing presence of the following skills",
      areas,
    },
    pyt: {
      error: "Error retrieving the questions. ",
      retry: "Try again",
      description: `
        <p>
          Play Your Test is an original questionnaire developed by Laborplay and 
          validated on a sample of over 25,000 people. The questions are used to 
          find out your gaming habits and preferences; your answers allow you to 
          develop a profile of your soft skills, which will help you reflect on 
          your strengths and areas for improvement.
        </p>
        <p>
          Play Your Test is not designed only for gamers or board game 
          enthusiasts.
        </p>
        <h4 class="superTitle" className="superTitle">Play Your Test is designed for everyone.</h4>
        <h4>Because we all know what we enjoy.</h4>
        <p>
          Answer by thinking about your preferences and, if you've never thought 
          about them before, now is the time! Then indicate the degree to which 
          you agree with the following statements.
        </p>
      `,
      start: "START THE TEST",
      guide: `
        <p>
        It is not important whether you are currently working or not, we just ask you to reflect on your preferences (even potential ones) and indicate the degree of agreement with the following statements. Using the scale below, please indicate how much you like the following aspects of a job. 
        <br />
        <b>WHAT DO YOU LIKE (OR WOULD LIKE) IN A JOB?</b>
        <br />
        <i>1 = totally agree, 2 = partially agree, 3 = partially disagree, 4 = totally disagree</i>
        </p>
      `,
      confirm: "Confirm",
    },
    profiles: {
      Analitico: "Analytical",
      Attivatore: "Motivating",
      Audace: "Bold",
      Brillante: "Brilliant",
      Carismatico: "Charismatic",
      Cauto: "Cautious",
      Collaborativo: "Collaborative",
      Determinato: "Determined",
      Disponibile: "Available",
      Equilibrato: "Balanced",
      Influente: "Influencer",
      Innovatore: "Innovative",
      Negoziatore: "Negotiator",
      Riflessivo: "Reflective",
      Sistematico: "Systematic",
      Socievole: "Sociable",
      Vivace: " Lively",
    },
    terms,
  },
};
